import { isMilestoneElement, isValidElementByType } from 'helpers/elementTypeCheckers';
import { ScheduleElementType } from 'state_management/scheduler/ScheduleElementType';

const setOnlyContainsMilestoneNodes = (selectedElements: Set<ScheduleElementType>): boolean => {
  if (selectedElements.size === 0) return false;

  for (const type of selectedElements) {
    if (!isMilestoneElement(type)) return false;
  }

  return true;
};

export const getFirstValidElementType = (
  selectedElements: {
    elementType: ScheduleElementType;
  }[]
): ScheduleElementType | undefined => {
  if (!selectedElements?.length) return undefined;

  const typeSet = new Set<ScheduleElementType>();

  for (const element of selectedElements) {
    if (element.elementType && isValidElementByType(element.elementType)) {
      typeSet.add(element.elementType);
    }
  }

  // If there is only one type, return it OR
  // If all elements are milestones, return the first milestone type
  if (typeSet.size === 1 || setOnlyContainsMilestoneNodes(typeSet)) {
    return typeSet.values().next().value;
  }

  return undefined;
};
